import React from 'react';
import _ from 'lodash';
import {connectWithCore} from 'framework/hocs';
import {connect} from 'react-redux';
import {Header, Dimmer, Loader, Segment, Form, Button} from 'semantic-ui-react';
import CommentList from 'go/components/comments/CommentList';
import {TextAreaFieldFrom as TextAreaField} from 'app-ui-componentlibrary';
import {TextBoxField} from 'app-ui-componentlibrary/dist/go/components/common/FormControls';
import ApiActions from 'go/actions/api';
import {API_COMMENT_POST_SUCCESS} from 'common/types';
import {ENTITY_PAGE_TYPE_GRANT} from 'app-ui-componentlibrary/dist/common/constants';

const emptyStr = '';

export class Comment extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      subject: emptyStr,
      comment: emptyStr,
      userComments: [],
    };
  }

  static defaultProps = {
    historyHeader: 'Comments history',
    excludedProcess: ['panel-review', 'panelReview'],
    emptyCommentsMessage: 'There are no comments on this grant.',
  };

  renderNoComments() {
    return <p>{this.props.emptyCommentsMessage}</p>;
  }

  filterComments = (comments) => {
    const {filterBytask} = this.props;
    return _.filter(comments, (comment) => {
      let validComment = true;
      if (filterBytask) {
        validComment = validComment && comment.task == filterBytask;
      }
      return validComment;
    });
  };

  renderComments = (data) => {
    const noCommentsView = this.renderNoComments();
    if (_.get(data, 'loading')) {
      return (
        <Dimmer active inverted>
          <Loader inverted />
        </Dimmer>
      );
    } else if (data && !_.isEmpty(data)) {
      const comments = this.filterComments(data);
      return _.size(comments) > 0 ? <CommentList comments={comments} /> : noCommentsView;
    } else {
      return noCommentsView;
    }
  };

  handleChange = (e) => {
    const {name, value} = e.target;
    this.setState({[name]: value});
  };

  handleSubmit = (e) => {
    e.preventDefault();
    const {subject, comment} = this.state;
    let {grantId, programId, organizationId} = this.props;
    const entityType = ENTITY_PAGE_TYPE_GRANT;
    if (subject && comment) {
      if (organizationId && organizationId != null) {
        let response = this.props.saveCommentWithOrgId(
          this.props.token,
          this.props.userId,
          subject,
          comment,
          grantId,
          programId,
          organizationId,
          entityType
        );
        response.then((res) => {
          this.handleResponseFromServer(res);
        });
      } else {
        // TODO remove OpenAPI toggle code
        let response = this.props.saveComment(
          this.props.token,
          this.props.userId,
          subject,
          comment,
          grantId,
          programId,
          entityType
        );
        response.then((res) => {
          this.handleResponseFromServer(res);
        });
      }
    }
  };

  handleResponseFromServer = (res) => {
    if (res !== undefined && res.type === API_COMMENT_POST_SUCCESS) {
      const newComment = res.payload[0];
      var commentList = _.values(this.props.data);

      this.setState({
        subject: emptyStr,
        comment: emptyStr,
        userComments: [newComment, ...commentList],
      });

      this.props.saveEntitySessionData('context.comment', this.state.userComments);
    }
  };

  render() {
    const {header, historyHeader, headerSize, readOnly, excludedProcess, id} = this.props;

    let data = _.filter(
      this.props.data,
      (comment) =>
        (!_.includes(excludedProcess, comment.process) && comment && !comment.status) ||
        comment.status == 200
    );

    return (
      <React.Fragment>
        {header && (
          <Header as={headerSize || 'h1'} id={id}>
            {header}
            <Header.Subheader>
              Add additional comments to the grant file.
            </Header.Subheader>
          </Header>
        )}
        {!readOnly && (
          <Form onSubmit={this.handleSubmit}>
            <TextBoxField
              value={this.state.subject}
              label="Subject"
              id="subject"
              title={'Required: Subject'}
              name="subject"
              handleChange={this.handleChange}
              handleBlur={this.handleBlur}
              maxLength={65}
            />
            <TextAreaField
              value={this.state.comment}
              label="Comment"
              id="comment"
              title="Required: Comment"
              name="comment"
              maxLength={4000}
              handleChange={this.handleChange}
              handleBlur={this.handleBlur}
            />
            <Form.Field>
              <Button
                primary
                disabled={
                  _.trim(this.state.subject) === emptyStr ||
                  _.trim(this.state.comment) === emptyStr
                }
                title="Submit comment"
              >
                Submit comment
              </Button>
            </Form.Field>
          </Form>
        )}
        <Header as="h3" id={id || ''}>
          {historyHeader}
        </Header>
        <Segment>{this.renderComments(data)}</Segment>
      </React.Fragment>
    );
  }
}

export const mapDispatchToProps = (dispatch) => ({
  saveComment: (token, userId, subject, comment, grantId, programId, entityType) => {
    // TODO remove OpenAPI toggle code
    const action = ApiActions.comments.saveComment(
      token,
      userId,
      subject,
      comment,
      grantId,
      programId,
      entityType
    );
    const response = dispatch(action);
    return response;
  },
  saveCommentWithOrgId: (
    token,
    userId,
    subject,
    comment,
    grantId,
    programId,
    organizationId,
    entityType
  ) => {
    const action = ApiActions.comments.saveCommentWithOrgId(
      token,
      userId,
      subject,
      comment,
      grantId,
      programId,
      organizationId,
      entityType
    );
    const response = dispatch(action);
    return response;
  },
});

export const mapStateToProps = (state, props) => {
  return {
    token: state.auth.token,
    userId: state.auth.userId,
    grantId: _.get(
      state,
      'dynamicComponent.context.grant.grantId',
      _.get(props, 'grantId')
    ),
    programId: _.get(
      state,
      'dynamicComponent.context.grant.programId',
      _.get(props, 'programId')
    ),
    toggles: state.toggles.toggles,
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(connectWithCore(Comment));
